import React from "react";
import { Modal, Button } from "@mantine/core";
import "./AreYouSureModal.css";

interface AreYouSureModalProps {
  opened: boolean;
  message: string;
  warning?: string;
  onClose: () => void;
  onAction: () => void;
}

const AreYouSureModal: React.FC<AreYouSureModalProps> = ({
  opened,
  message,
  warning,
  onClose,
  onAction,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Upozorenje!"
      centered
      size="md"
      transitionProps={{ transition: "fade-up" }}
      withCloseButton={false}
      classNames={{
        content: "are-you-sure-content",
        header: "are-you-sure-header",
        title: "are-you-sure-title",
      }}
    >
      <div className="px-2 text-[#0b1a29] text-md font-medium">{message}</div>
      {warning && (
        <div className="px-2 mt-3 text-[#0b1a29] text-[0.7125rem] font-normal">
          {warning}
        </div>
      )}
      <div className="ays-button-container">
        <Button
          variant="outline"
          color="#004a99"
          radius="xl"
          size="md"
          className="ays-button"
          onClick={onAction}
        >
          Obriši
        </Button>
        <Button
          variant="filled"
          color="#004a99"
          radius="xl"
          size="md"
          className="ays-button"
          onClick={onClose}
        >
          Odustani
        </Button>
      </div>
    </Modal>
  );
};

export default AreYouSureModal;
